export default "__VITE_ASSET__Buga3Una__"